import {Heading, Text} from '@primer/react-brand'
import {useRef} from 'react'
import {clsx} from 'clsx'

import ImageGithubMarkWave from '../../assets/images/githubMarkWave.svg'

import Styles from './ThankYou.module.css'
import {useIntersectionObserver} from '@github-ui/swp-core/lib/hooks/use-intersection-observer'

export interface ThankYouProps {
  heading: string
  body: string
}

export const ThankYou = ({heading, body}: ThankYouProps) => {
  const iconRef = useRef<HTMLDivElement>(null)
  const {isIntersecting: isIconVisible} = useIntersectionObserver(iconRef, {threshold: 0.5, isOnce: true})

  return (
    <section className={Styles['ThankYou']}>
      <div
        ref={iconRef}
        className={clsx(Styles['ThankYou__icon'], {[Styles['ThankYou__icon--animating']]: isIconVisible})}
        style={{'--bgImage': `url(${ImageGithubMarkWave})`}}
      />

      <Heading as="h3" size="5" className={Styles['ThankYou__heading']} weight="normal">
        {heading}
      </Heading>
      <Text className={Styles['ThankYou__body']} variant="muted">
        {body}
      </Text>
    </section>
  )
}
